import axios from 'axios';

export default {
    get: url => axios.get(url).then(res => res),
    post: (url, data) => {
        if (data instanceof FormData) {
            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                transformRequest: [],
            };
            return axios.post(url, data, config);
        } else {
            return axios.post(url, data).then(res => res);
        }
    },
    put: (url, data) => axios.put(url, JSON.stringify(data)).then(res => res),
    patch: (url, data) => axios.patch(url, JSON.stringify(data)).then(res => res),
    delete: url => axios.delete(url).then(res => res),
};
